import axios from 'axios';
import EncodeDecodeType from '../actiontype/encode-decode-type';
import OnlineEncodeDecodeService from './online-encdec.service';
import CustomHttpConfigService from './custom-http-config.service';
import querystring from 'querystring';
import UtilService from './util.service';
import ChatBotEncodeDecodeService from './chatbot-encdec.service';
import { SentryService } from './sentry-service';

export default class CustomHttpService {
    static getAll(urls) {
        return axios.all(urls);
    }

    static post(url, data, config, encodeDecodeType, retry_count) {
        config["url"] = url;
        config["data"] = data;
        switch (encodeDecodeType) {
            case EncodeDecodeType.CHATBOT:
                CustomHttpConfigService.addDefaultChatbotConfig(config);
                return _chatbotPost(url, data, config);
            case EncodeDecodeType.ONLINE:
                CustomHttpConfigService.addDefaultOnlineConfig(config);
                CustomHttpConfigService.addNonMobileAppHeaders("POST", config);
                return _onlinePost(url, data, config);
            case EncodeDecodeType.HELPSUPPORT:
                if (UtilService.isMobileApp()) {
                    url = CustomHttpConfigService.getUrlForApp(url);
                    config.url = url;
                    CustomHttpConfigService.addDefaultConfig(config);
                    return _mobileAppPost(url, data, config);
                }
                else {
                    CustomHttpConfigService.addDefaultHelpSupportConfig(config);
                    CustomHttpConfigService.addNonMobileAppHeaders("POST", config);
                    return _helpSupportPost(url, config.data, config);
                }
            case EncodeDecodeType.URL_FORM_ENCODED:
                CustomHttpConfigService.addDefaultConfig(config);
                return _getUrlFormEncodedPost(url, data, config, retry_count);
            case EncodeDecodeType.DEFAULT:
                CustomHttpConfigService.addDefaultConfig(config);
                return _defaultPost(url, data, config);
            default:
                throw new Error('EncodeDecodeType missing');
        }
    }

    static get(url, config, encodeDecodeType, retry_count) {
        config["url"] = url;
        switch (encodeDecodeType) {
            case EncodeDecodeType.CHATBOT:
                CustomHttpConfigService.addDefaultChatbotConfig(config);
                return _chatbotGet(url, config);
            case EncodeDecodeType.ONLINE:
                CustomHttpConfigService.addDefaultOnlineConfig(config);
                CustomHttpConfigService.handleMobileAppHeaders("GET", config, EncodeDecodeType.ONLINE)
                return _onlineGet(url, config);
            case EncodeDecodeType.HELPSUPPORT:
                if (UtilService.isMobileApp()) {
                    url = CustomHttpConfigService.getUrlForApp(url);
                    config.url = url;
                    CustomHttpConfigService.addDefaultConfig(config);
                    return _mobileAppGet(url, config);
                }
                else {
                    CustomHttpConfigService.addDefaultHelpSupportConfig(config);
                    CustomHttpConfigService.addNonMobileAppHeaders("GET", config);
                    return _helpSupportGet(url, config);
                }
            case EncodeDecodeType.DEFAULT:
                CustomHttpConfigService.addDefaultConfig(config);
                return _defaultGet(url, config);
            default:
                throw new Error('EncodeDecodeType missing');
        }
    }
}


const _getUrlFormEncodedPost = (url, data, config, retry_count) => {
    return axios.post(url, querystring.stringify(data), config).then(
        response => {
            return _getTransformedResponseForChatbot(response);
        },
        error => {
            SentryService.captureApiError({errorInfo: error, url, method: 'POST', options: config.headers, body: data})
            throw error
        }
    )
}

const _chatbotGet = (url, config) => {
    return axios.get(url, config).then(
        response => {
            return _getTransformedResponseForChatbot(response);
        }
    )
}

const _chatbotPost = (url, data, config) => {
    return axios.post(url, { message: ChatBotEncodeDecodeService.encode(data) }, config).then(
        response => {
            return _getTransformedResponseForChatbot(response);
        }
    );
}

const _defaultGet = (url, config) => {
    return new Promise((resolve, reject) => {
        axios.get(url, config).then(

            response => {
                resolve(response)
            },
            error => {
                SentryService.captureApiError({errorInfo: error, url, method: 'GET', options: config.headers})
                if (error && error.response && error.response.status && error.response.status === 401) {
                    reject(error)
                }
                else {
                    reject(error)
                }
            }
        )
    })
}

const _defaultPost = (url, data, config) => {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config).then(

            response => {
                resolve(response)
            },
            error => {
                SentryService.captureApiError({errorInfo: error, url, method: 'POST', options: config.headers, body: data})
                if (error && error.response && error.response.status && error.response.status === 401) {
                    reject(error)
                }
                else {
                    reject(error)
                }
            }
        )
    })
}

const _onlineGet = (url, config) => {
    return axios.get(url, config).then(
        response => {
            return _getTransformedResponseForOnline(response);
        },
        error => {
            SentryService.captureApiError({errorInfo: error, url, method: 'GET', options: config.headers})
            throw error
        }
    )
}

const _onlinePost = (url, data, config) => {
    return axios.post(url, data, config).then(
        response => {
            return _getTransformedResponseForOnline(response);
        },
        error => {
            SentryService.captureApiError({errorInfo: error, url, method: 'POST', options: config.headers, body: data})
            throw error
        }
    );
}

const _helpSupportGet = (url, config) => {
    return axios.get(url, config).then(
        response => {
            return _getTransformedResponseForOnline(response);
        },
        error => {
            SentryService.captureApiError({errorInfo: error, url, method: 'GET', options: config.headers})
            throw error
        }
    )
}

const _helpSupportPost = (url, data, config) => {
    return axios.post(url, data, config).then(
        response => {
            return _getTransformedResponseForOnline(response);
        },
        error => {
            SentryService.captureApiError({errorInfo: error, url, method: 'POST', options: config.headers, body: config.data})
            throw error
        }
    );
}

const _getTransformedResponseForChatbot = (response) => {
    if (response && response.data && response.headers) {
        switch (UtilService.isResponseContentTypeHtml(response)) {
            case true:
                return response;
            default:
                return _getDecryptedResonseForChatbot(response);
        }
    }
}

const _getTransformedResponseForOnline = (response) => {
    if (response && response.data && response.headers) {
        switch (UtilService.isResponseContentTypeHtml(response)) {
            case true:
                return response;
            default:
                return _getDecryptedResonseForOnline(response);
        }
    }
}

const _getDecryptedResonseForChatbot = (response) => {
    if (response) {
        const decryptedData = ChatBotEncodeDecodeService.decode(response.data);
        response.data = decryptedData;
        return response;
    }
    return null;
}

const _getDecryptedResonseForOnline = (response) => {
    const decryptedData = JSON.parse(OnlineEncodeDecodeService.decryptForOTP(response.data, response.headers["googlecookie"]));
    response.data = decryptedData;
    return response;
}

const _mobileAppGet = (url, config) => {
    return new Promise((resolve, reject) => {
        CustomHttpConfigService.addAppHeaders(url, 'GET', config).then(value => {
            axios.get(url, config).then(response => {
                resolve(response)
            }, error => {
                SentryService.captureApiError({errorInfo: error, url, method: 'GET', options: config.headers})
                reject(error)
            })

        }).catch(e => {
            reject (e)
        })
    })
}

const _mobileAppPost = (url, data, config) => {
    return new Promise((resolve, reject) => {
        CustomHttpConfigService.addAppHeaders(url, "POST", config).then(value => {
            axios.post(url, data, config).then(response => {
                resolve(response)
            }, error => {
                SentryService.captureApiError({errorInfo: error, url, method: 'POST', options: config.headers, body: data})
                reject(error)
            })

        }).catch(e => {
            reject(e)
        })
    })
}